// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__I36Zr","list":"BalanceDue_list__OP6QD","listRow":"BalanceDue_listRow__tc4y3","total":"BalanceDue_total__2R3-V"};